<template>
    <div class="app-main">
        <!-- 顶部 -->
        <el-row type="flex" class="app-main-header" align="middle">
            <!-- 页面title -->
			<el-col :span="6">
				<div class="router-title">
					<i class="el-icon-s-home"></i><span style="margin-left: 5px;">{{ $route.meta.title }}</span>
				</div>
			</el-col>
            <!-- 批量操作 -->
			<el-col :span="18" class="app-main-header-btns">

            </el-col>
        </el-row>
        <el-row class="mg-b5">
            <el-card class="box-card">
                <!-- 顶部搜索 -->
				<div slot="header" class="clearfix">
					<el-form :inline="true" class="demo-form-inline">
						<!-- <el-form-item class="my-form-item">
							<el-date-picker
                                size="mini"
                                :unlink-panels="true"
                                type="daterange"
                                range-separator="-"
                                v-model="quertInfo.searchTime"
                                start-placeholder="开始日期"
                                value-format="yyyy-MM-dd"
                                style="width: 200px"
                                end-placeholder="结束日期">
							</el-date-picker>
						</el-form-item>
						<el-form-item class="my-form-item">
                            <el-select v-model="quertInfo.objMap.status" style="width: 100%" size="small" clearable  placeholder="请选择供应商状态">
                                <el-option label="未审核" :value="1"></el-option>
                                <el-option label="审核通过" :value="2"></el-option>
                                <el-option label="驳回" :value="3"></el-option>
                            </el-select>
						</el-form-item> -->
						<el-form-item class="my-form-item">
							<el-input size="mini" placeholder="请输入企业名称关键字查询" clearable v-model="quertInfo.objMap.search" style="width: 250px" prefix-icon="el-icon-search"></el-input>
						</el-form-item>
						<el-form-item class="my-form-item">
							<el-button size="mini" type="primary" @click="onSearch" >查询 </el-button>
						</el-form-item>
					</el-form>
				</div>
                <div class="table-box">
                    <!-- 表格 -->
                    <el-table :data="tableData" border size="mini" :header-cell-style="headerCellStyle" :height="PAGESIZE.h-200" @selection-change="handleSelectionChange">
                        <!-- <el-table-column type="selection" width="40" align="left"> </el-table-column> -->
                        <el-table-column prop="name" label="企业名称" :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <el-button type="text" @click="showInfo(scope.row)">{{scope.row.name}}</el-button>
                            </template>
                        </el-table-column>
                        <el-table-column prop="tyShXxCode" label="统一社会信息代码" :show-overflow-tooltip="true" width="120"> </el-table-column>
                        <el-table-column prop="qyTyoe" label="企业类型" :show-overflow-tooltip="true" width="120"> </el-table-column>
                        <el-table-column prop="taxpayerSign" label="纳税人标识" :show-overflow-tooltip="true" width="120"> </el-table-column>
                        <el-table-column prop="manageArea" label="经营范围" :show-overflow-tooltip="true"> </el-table-column>
                        <el-table-column prop="zyClass" label="主营品类" :show-overflow-tooltip="true"> </el-table-column>
                         <el-table-column prop="jyXz" label="经营性质" :show-overflow-tooltip="true" width="120"> </el-table-column>
                        <el-table-column prop="hyType" label="行业类型" :show-overflow-tooltip="true" width="120"> </el-table-column>
                        <el-table-column prop="shFwScope" label="送货服务范围" :show-overflow-tooltip="true" width="120"> </el-table-column>
                        <el-table-column prop="gsGw" label="公司官网" :show-overflow-tooltip="true" width="120"> </el-table-column>
                        <el-table-column prop="status" label="审核状态" :show-overflow-tooltip="true" width="120" :formatter="statusFormatter"> </el-table-column>

                        <!-- <el-table-column prop="qyShort" label="企业简称" :show-overflow-tooltip="true" width="120"> </el-table-column>
                        <el-table-column prop="createTime" label="创建时间" :show-overflow-tooltip="true" width="120"> </el-table-column>
                        <el-table-column prop="rzRegion" label="认证地区" :show-overflow-tooltip="true" width="120"> </el-table-column>
                        <el-table-column prop="englishName" label="英文名称" :show-overflow-tooltip="true" width="120"> </el-table-column>
                        <el-table-column prop="orgJgCode" label="组织机构代码" :show-overflow-tooltip="true" width="120"> </el-table-column>
                        <el-table-column prop="country" label="注册国家/地区" :show-overflow-tooltip="true" width="120"> </el-table-column>
                        <el-table-column prop="address" label="详细地址" :show-overflow-tooltip="true" width="120"> </el-table-column>
                        <el-table-column prop="legalPerson" label="法定代表人" :show-overflow-tooltip="true" width="120"> </el-table-column>
                        <el-table-column prop="zcCapital" label="注册资本" :show-overflow-tooltip="true" width="120"> </el-table-column>
                        <el-table-column prop="zcCurrency" label="注册资本货币种类(万)" :show-overflow-tooltip="true" width="120"> </el-table-column>
                        <el-table-column prop="foundDate" label="建立日期" :show-overflow-tooltip="true" width="120"> </el-table-column>
                        <el-table-column label="附件" width="95">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.yyZzSrc==undefined" type="info">无附件 </el-tag>
                                <el-link v-else :underline="false" :href="baseURL+scope.row.yyZzSrc" target="_blank">
                                    <el-tag type="success">查看附件</el-tag>
                                </el-link>
                            </template>
                        </el-table-column>
                        <el-table-column prop="zySf" label="主要身份" :show-overflow-tooltip="true" width="120"> </el-table-column>
                        <el-table-column prop="gsLogoSrc" label="公司Logo" :show-overflow-tooltip="true" width="120"> </el-table-column>
                        <el-table-column prop="gsDetail" label="公司简介(以上是业务信息)" :show-overflow-tooltip="true" width="120"> </el-table-column>
                        <el-table-column prop="invoiceHead" label="发票头" :show-overflow-tooltip="true" width="120"> </el-table-column>
                        <el-table-column prop="swDjh" label="税务登记号" :show-overflow-tooltip="true" width="120"> </el-table-column>
                        <el-table-column prop="khhName" label="开户行" :show-overflow-tooltip="true" width="120"> </el-table-column>
                        <el-table-column prop="khhNumber" label="开户行账号" :show-overflow-tooltip="true" width="120"> </el-table-column>
                        <el-table-column prop="swDjDz" label="税务登记地址" :show-overflow-tooltip="true" width="120"> </el-table-column>
                        <el-table-column prop="swDjDh" label="税务登记电话" :show-overflow-tooltip="true" width="120"> </el-table-column>
                        <el-table-column prop="sprEmail" label="收票人邮箱" :show-overflow-tooltip="true" width="120"> </el-table-column>
                        <el-table-column prop="sprDh" label="收票人电话(以上是开票信息)" :show-overflow-tooltip="true" width="120"> </el-table-column>
                        <el-table-column prop="qyXz" label="企业性质" :show-overflow-tooltip="true" width="120"> </el-table-column> -->
                        <el-table-column label="操作" width="120" align="left" fixed="right">
                            <template slot-scope="scope">
                                <!-- 0，草稿，1未审核，3驳回，2 审核通过 -->
                                <el-button type="text" size="small" v-if="scope.row.status!=1" :disabled="true" @click="auditOpen(scope.row)">审核</el-button>
                                <el-link class="el-link-s" :underline="false" v-if="scope.row.status==1" :href="`/gys/showgysinfo/${scope.row.id}?hide=1`" target='_blank' type="primary">审核</el-link>
                                <el-button type="text" size="small" :disabled="scope.row.status==0" @click="showAuditInfo(scope.row)" >审核详情 </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-card>
        </el-row>
        <!-- 分页 -->
        <el-row type="flex" justify="end" class="mg-t5">
            <pagination v-show="count>0" @on-pagination="onPagination" :page.sync="quertInfo.page"
                        :limit.sync="quertInfo.limit" :total="count">
            </pagination>
        </el-row>
        <!-- 审核 -->
        <AuditGys ref="AuditGysRef" @callback="AuditGysCallback" />
        <ShowGysInfo ref="ShowGysInfoRef" @callback="ShowGysInfoCallback"/>
    </div>
</template>

<script>
import { supplierInfoList ,queryByParentId, auditBasicInfo,getSupplierApprovalRecordList} from '@/api/gysmng/index';
import ShowGysInfo from '../../../components/ShowGysInfo'
import AuditGys from './AuditGys.vue'
export default {
    data() {
        return {
            tableData: [],
            count:0,
            quertInfo: {
                page: 1, //当前页码
                limit: 20, //当前每页显示的数量
                searchTime:[],
                objMap: {
                    // status:'',
                    firstRegist:'是',
                    search:'',

                    // gysType: 0,
                }
            },
            ids:[],

        };
    },
    created() {
        this.getList()
    },
    components: {
        ShowGysInfo,AuditGys
    },
    methods: {
        showInfo(row){
            // this.$refs.ShowGysInfoRef.show('audit',row)
            this.$router.push({path: `/gys/newgysinfo/${row.id}?hideaudit=1`});
            // this.$router.push({path: `/gys/newgysinfo/${row.supplierInfoId}?hideaudit=1`});
        },
        onPagination: function (val) {
			this.quertInfo.page = val.page;
			this.quertInfo.limit = val.limit;
			this.getList();
		},
        async getList() {
            let _this = this;
            const {
                data: res
            // } = await supplierInfoList(_this.quertInfo)
            } = await getSupplierApprovalRecordList(_this.quertInfo)
            if (res.code == 0) {
                _this.tableData = res.data;
                _this.count = res.count;
            }
        },
        onSearch(){
            this.quertInfo.page = 1;
			this.getList();
        },
        handleSelectionChange(val) {
			this.ids = [];
			for (let item of val) {
				this.ids.push(item.id);
			}
		},
        auditOpen(row){
            // this.form={
            //     id:row.id,
            //     status:2,
            //     gys_type:1,
            //     supplier_classification_id:undefined,
            //     reason:'',
            // };
            // if (this.$refs["form"] !== undefined) {
			// 	this.$refs["form"].resetFields();
			// }
            // this.openDialog = true;
            // this.getTreeselect()
            this.$refs.AuditGysRef.auditOpen(row)
        },
        AuditGysCallback(obj){
            if(obj.type == 'getList'){
                this.getList();
            }
        },
        ShowGysInfoCallback(obj){
            if(obj.type == 'audit'){
                if(obj.back == 'getList'){
                    this.getList();
                }
            }
        },
        statusFormatter(row){
            // 0，草稿，1未审核，3驳回，2 审核通过
            if(row){
                if(row.status == 2){
                    return '通过'
                }else if(row.status == 3){
                    return '驳回'
                }else if(row.status == 1){
                    return '待审核'
                }else{
                    return '草稿'
                }
            }else{
                return ''
            }
        },
        showAuditInfo(row){
			// this.$router.push({path: '/gys/showauditinfo/'+row.id});
			// window.open(`/gys/showgysinfo/${row.id}?hide=1`)
			window.open(`/gys/showauditinfo/${row.id}`)
		},
    },

    mounted() {

    },
    computed: {
        PAGESIZE:function(){
			return this.$store.getters['app/sizeInfo'];
		},
    },
    watch: {

    },
};
</script>

<style scoped lang="scss">
::v-deep .el-link-s{
    font-size: 12px!important;
    margin-right: 12px;
    line-height: 1!important;
    position: relative;
    top: -1px;
}
</style>
